<script>
  import { mapStores } from "pinia";
  import { RouterView } from "vue-router";

  import TheModalConfirm from "@/components/TheModalConfirm.vue";
  import TheModalIndication from "@/components/TheModalIndication.vue";
  import ThePageFooter from "@/components/ThePageFooter.vue";
  import ThePageHeader from "@/components/ThePageHeader.vue";
  import ThePageLoadingIndicator from "@/components/ThePageLoadingIndicator.vue";
  import router from "@/router";
  import { useAppStore } from "@/stores/app.js";
  import { useAuthStore } from "@/stores/auth.js";

  export default {
    name: "App",
    components: {
      TheModalConfirm,
      RouterView,
      TheModalIndication,
      ThePageFooter,
      ThePageHeader,
      ThePageLoadingIndicator,
    },
    computed: {
      ...mapStores(useAppStore, useAuthStore),
      isPublicPage() {
        return router.currentRoute.value.meta.isPublicPage ?? false;
      },
    },
    watch: {
      $route(to, from) {
        const oldBodyClass = from.meta.bodyClass;
        const newBodyClass = to.meta.bodyClass;

        if (oldBodyClass) {
          document.body.classList.remove(oldBodyClass);
        }
        if (newBodyClass) {
          document.body.classList.add(newBodyClass);
        }
      },
    },
    async created() {
      await this.appStore.loadRuntimeEnvironment();
    },
    mounted() {
      const bodyClass = router.currentRoute.value.meta.bodyClass;

      if (bodyClass) {
        document.body.classList.add(bodyClass);
      }
    },
    beforeUnmount() {
      const bodyClass = router.currentRoute.value.meta.bodyClass;

      if (bodyClass) {
        document.body.classList.remove(bodyClass);
      }
    },
  };
</script>

<template>
  <div v-if="authStore.authenticated || isPublicPage" class="app">
    <TheModalIndication />
    <TheModalConfirm />
    <ThePageLoadingIndicator />

    <ThePageHeader
      :user-name="authStore.idTokenParsed ? authStore.idTokenParsed.name : 'unbekannter Nutzer'"
    />
    <RouterView />
    <ThePageFooter />
  </div>
</template>

<style lang="scss">
  @import "@/styles/imports";

  .app {
    background: var(--dps-color-white);
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: minmax(0, 1fr); // prevent grid blowout
    min-height: 100vh;
  }
</style>
